<script>
  import { createEventDispatcher } from "svelte";
  import Button from "../UI/Button.svelte";

  const dispatch = createEventDispatcher();

  let selectedButton = "ALL";
  let isFavorite = false;
</script>

<style lang="scss">
  @import "../style/theme-config.scss";

  .controls-position {
    padding: 0 0 3rem;
  }

  .favorite,
  .add {
    cursor: pointer;

    svg {
      width: 48px;
      height: 48px;
      fill: $color-highlight;
    }
  }
</style>

<div class="controls-position">
  <Button
    on:click={() => {
      selectedButton = 'ALL';
      dispatch('click', selectedButton);
    }}
    className={selectedButton === 'ALL' ? 'active' : ''}>
    All
  </Button>
  <span
    on:click={() => {
      selectedButton = 'FAV';
      dispatch('click', selectedButton);
    }}
    class={selectedButton ? 'favorite active' : 'favorite'}>
    {#if selectedButton === 'FAV'}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24px"
        height="24px">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5
          3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22
          8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
    {:else}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24px"
        height="24px">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2
          5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22
          12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24
          4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46
          5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" />
      </svg>
    {/if}
  </span>
  <Button
    on:click={() => {
      selectedButton = 'C';
      dispatch('click', selectedButton);
    }}
    className={selectedButton === 'C' ? 'active' : ''}>
    Centre
  </Button>
  <Button
    on:click={() => {
      selectedButton = 'L';
      dispatch('click', selectedButton);
    }}
    className={selectedButton === 'L' ? 'active' : ''}>
    Left Wing
  </Button>
  <Button
    on:click={() => {
      selectedButton = 'R';
      dispatch('click', selectedButton);
    }}
    className={selectedButton === 'R' ? 'active' : ''}>
    Right Wing
  </Button>
  <Button
    on:click={() => {
      selectedButton = 'D';
      dispatch('click', selectedButton);
    }}
    className={selectedButton === 'D' ? 'active' : ''}>
    Defence
  </Button>
  <Button
    on:click={() => {
      selectedButton = 'G';
      dispatch('click', selectedButton);
    }}
    className={selectedButton === 'G' ? 'active' : ''}>
    Goalie
  </Button>
  <span
    on:click={() => {
      selectedButton = 'ADD';
      dispatch('click', selectedButton);
    }}
    class="add">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px">
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9
        2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1
        9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" />
    </svg>
  </span>
</div>
